<template>
    <div class="modal fade" id="unbook-day-modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span>Avboka dag <span id="unbook-day-modal-date"></span></span>
                        <span class="hidden" id="unbook-day-modal-date-hidden"></span>
                        <span class="hidden" id="unbook-day-modal-therapist-hidden"></span>
                        <span class="hidden" id="unbook-day-modal-location-hidden"></span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal">
                        <span><b>x</b></span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="form-group">
                        <label>Från</label>
                        <input type="time" v-model="from" class="form-control">
                    </div>
                    <div class="form-group">
                        <label>Till</label>
                        <input type="time" v-model="to" class="form-control">
                    </div>
                    <div class="form-check mb-5">
                        <input class="form-check-input" type="checkbox" value="1" v-model="preliminary" id="preliminary">
                        <label class="form-check-label" for="preliminary">Preliminär avbokning</label>
                    </div>
                    <div>
                        <label for="message">{{ transEdit('Valfritt meddelande till kund')}}</label>
                        <textarea name="message" class="form-control" v-model="message"></textarea>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger"
                            v-on:click="unbookDay()"><i class="fa fa-trash"></i> {{transEdit('unbook')}}</button>
                    <button class="btn btn-dark"
                            data-dismiss="modal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "therapist-dash-modal-unbook-day",
        props: ['route_unbook_day'],
        data() {
            return {
                message: '',
                preliminary: false,
                from: null,
                to: null,
            }
        },
        methods: {
            unbookDay: function () {
                let self = this;
                let thisModal = $("#unbook-day-modal");
                let unbookDate = $("#unbook-day-modal-date-hidden").text();
                let unbookTherapist = $("#unbook-day-modal-therapist-hidden").text();
                let unbookLocation = $("#unbook-day-modal-location-hidden").text();

                axios.post('/schedules/unbook-day', {
                    date: unbookDate,
                    from: this.from,
                    to: this.to,
                    preliminary: this.preliminary,
                    therapist: unbookTherapist,
                    location: unbookLocation,
                    message: this.message,
                })
                .then(function (response) {
                    self.$emit('refresh');
                })
                .catch(function (error) {
                });

                thisModal.modal('toggle');
            }
        }
    }
</script>

<style scoped>

</style>
